import * as yup from 'yup';

export const schemaLogin = yup.object().shape({
  username: yup.string().required('Campo obbligatorio'),
  password: yup.string().required('Campo obbligatorio'),
});
